<template>
  <el-dialog class="demand_model_dialog" top="5vh" center title="完结工单" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="分类" prop="classify" :label-width="formLabelWidth">
        <el-select size="mini"   v-model="form.classify" filterable placeholder="请选择">
          <el-option v-for="(key, value) in NewworkOrderConfig" :key="key.value" :label="key.value" :value="key.key">
          </el-option>
        </el-select>
        <el-tooltip class="item" effect="dark" content="新增分类" placement="top">
          <span @click="dialogVisibleAddCateGory = true"  class="el-icon-plus addCategory">新增分类</span>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="处理结果" prop="dispose_result" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog" :content="form.dispose_result" @contentData="changeContent"
                :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <el-form-item label="处理凭证" prop="dispose_proof" :label-width="formLabelWidth">
        <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
                   :on-preview="handlePreview" :before-remove="beforeRemove" multiple :limit="5" :on-success="handleSuccess"
                   :on-remove="handleRemove" :before-upload="beforeUpload" :file-list="fileList">
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  type="warning"  :loading="loading.submit"  @click="onSubmit()">确 定</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <el-dialog center :append-to-body="true" title="新增分类" :visible.sync="dialogVisibleAddCateGory" width="40%">
      <el-form :model="categoryForm" :rules="categoryRules" ref="categoryForm" >
        <el-form-item label="分类名称" prop="module_value" label-width="72px" >
          <el-input  v-model="categoryForm.module_value" autocomplete="off">
          </el-input>
        </el-form-item>
        <div style="margin:0 auto;text-align: center">
          <el-button size="small" type="primary" @click="onAddCateGory" :loading="loading.addCategoryLoad">确 定</el-button>
          <el-button size="small" @click="dialogVisibleAddCateGory = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"

import {
  getDevOpsSpaceProducerListApi, postDevOpsSpaceClaimWorkOrderApi, postDevOpsSpaceCreateSystemApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceWorkOrderConfigApi} from "@/server/tops/base";
export default {
  components: {Editor},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    workId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        dispose_result:'',
      },

      rules: {
        dispose_result: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        classify: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
      },
      userNameInfo:'',
      fileList:[],
      NewworkOrderConfig:{},
      dialogVisibleAddCateGory: false,
      categoryForm:{
        module_value:'',
        work_type:'6',
      },
      categoryRules:{
        module_value: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
    };
  },
  async mounted() {
    const { id = '', acceptor_id='',level='',classify='', state_code = '',classify_code=''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const username_cn = this.$store.state.devOps.userInfo.user_name_zh? this.$store.state.devOps.userInfo.user_name_zh : '';
    this.form = { ...this.form, workId:id, work_state:state_code,acceptor_id,level,classify,classify_code}
    if(this.form.classify_code){
      this.form.classify = Number(this.form.classify_code);
    }
    this.$set(this.form, 'username', username)
    this.username = username;
    this.userNameInfo = username_cn + '('+username+')';
    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }
    this.NewworkOrderConfig = this.workOrderConfig.CATEGORY
    //获取未开始，进行中的项目
    this.$nextTick(async () => {
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          workOrderConfig: (state) => state.devOps.WORKORDERCONFIG,
        }
    ),
  },
  methods: {
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    beforeUpload(file){
      if (file.size / 1024 / 1024   > 5) {
        this.$notify({
          message:  "上传文件大小不能超过5M!",
          type: "error",
        });
        return false;
      }
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.dispose_result = val;
    },
    onSubmit(){
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.workId= this.workId;
          if (this.fileList.length > 0) {
            this.form.dispose_proof = JSON.stringify(this.fileList);
          }
          try {
            this.$set(this.loading, 'submit', true)
            await postDevOpsSpaceClaimWorkOrderApi({...this.form,type:'3'}).then((ret)=>{
              if (ret.status === 'success') {
                this.$notify({
                  message: ret.message || '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.loading.submit = false;
                this.$notify({
                  message: ret.message || "失败",
                  type: "error",
                })
              }
            })
          }catch (error) {
            this.loading.submit = false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          }finally {
            this.loading.submit = false;
          }

        }
      });

    },
    onAddCateGory(){
      this.$refs["categoryForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.$set(this.loading, 'addCategoryLoad', true);
            const ret =  await postDevOpsSpaceCreateSystemApi(this.categoryForm);
            if (ret.status === 'success') {
              this.dialogVisibleAddCateGory = false;
              this.loading.addCategoryLoad =  false;
              await this.getWorkOrderConfig();
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.loading.addCategoryLoad =  false;
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.loading.addCategoryLoad =  false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.addCategoryLoad =  false;
          }
        }

      })
    },
    async getWorkOrderConfig() {
      await getDevOpsSpaceWorkOrderConfigApi({type: '6'}).then((res) => {
        let category = [];
        res.data.forEach((item, index) => {
          category.push({key:item.key,value:item.value});
        });
        this.NewworkOrderConfig = category;
      })
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

</style>
